export default __webpack_public_path__ + "static/media/icon-arrow-cycle.5228e2c7.svg";